import { PureComponent } from 'react';
import { blogArticles } from '../../constants/tools';
import i10n from '../../common/i10n'
import { connect } from 'react-redux';
import BlogArticle from './blogArticle';
import { AsyncSVG } from './AsyncSVG';

class BlogToolComponent extends PureComponent {

    constructor(props) {
        super(props);

    }

    render() {
        /* in real life, we need to have a default value which is the article embeded for all widget and "extra articles" coming from the tool 
            so we need to merge the default array of articles with the array (which can be empty) provided by the tool */
        var defaultBlogs = [blogArticles.default];

        var toolBlogs = this.props.blogFromTools;
        if (toolBlogs != null) {
            var blogs = [...toolBlogs, ...defaultBlogs].slice(0, 3);
        }
        else {
            var blogs = defaultBlogs;
        }

        return (
            <div className="row blog-articles">
                <div className="col-md-12">
                    <div className="row ave-row-small">
                        <div className="col-12">
                            <h3 className="title-fancy title-small mb-5">
                                <span className="title-fancy-icon"><AsyncSVG className="link-arrow" src='/images/title-icon.svg' /></span>
                                {i10n._BLOG_TITLE}
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="row">
                        {
                            blogs.map(function (article, index) {
                                return (<div key={index} className="col-xl-4 col-lg-6 col-md-6 mb-4">
                                    {
                                        <BlogArticle blog={article} />
                                    }
                                </div>)
                            })
                        }
                    </div>
                </div>
            </div>);
    }
}



const mapState = ({ tool }) => {
    return {
        language: tool.lang
    };
}
const BlogTool = connect(mapState)(BlogToolComponent);
export default BlogTool;